import { jsx as _jsx } from "react/jsx-runtime";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
/**
 * A helper component to convert SDUI server responsive values into RSC-friendly content that is client responsive.
 */ export var SDUIResponsiveContent = function(param) {
    var defaultValue = param.defaultValue, convertValueToReactElement = param.convertValueToReactElement, serverResponsiveValues = param.serverResponsiveValues;
    if (!serverResponsiveValues) {
        return convertValueToReactElement(defaultValue);
    }
    var _serverResponsiveValues_mobile_and_above;
    var mobileValue = (_serverResponsiveValues_mobile_and_above = serverResponsiveValues.mobile_and_above) !== null && _serverResponsiveValues_mobile_and_above !== void 0 ? _serverResponsiveValues_mobile_and_above : defaultValue;
    var _serverResponsiveValues_tablet_and_above;
    var tabletValue = (_serverResponsiveValues_tablet_and_above = serverResponsiveValues.tablet_and_above) !== null && _serverResponsiveValues_tablet_and_above !== void 0 ? _serverResponsiveValues_tablet_and_above : mobileValue;
    var _serverResponsiveValues_desktop_and_above;
    var desktopAndAboveValue = (_serverResponsiveValues_desktop_and_above = serverResponsiveValues.desktop_and_above) !== null && _serverResponsiveValues_desktop_and_above !== void 0 ? _serverResponsiveValues_desktop_and_above : tabletValue;
    return /*#__PURE__*/ _jsx(ResponsiveContentV2, {
        mobile: convertValueToReactElement(mobileValue),
        tablet: convertValueToReactElement(tabletValue),
        desktopAndAbove: convertValueToReactElement(desktopAndAboveValue),
        noJS: true
    });
};
